<div class="chart-box">
  <span>{{title}}</span>
  <lucide-icon name="info" ngbTooltip="{{description}}" size="16"></lucide-icon>
  @if (loading) {
    <div class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
      <div class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }
  @if (!loading && barChartData!==null) {
    <div style="display: block;max-height: 800px">
      <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="pieChartOptions" [legend]="barChartLegend" [type]="barChartType" id="pie_{{index}}">
      </canvas>
      <a href="#" (click)="downloadCanvas($event)" class="btn btn btn-outline-primary">
        <lucide-icon name="image" size="16"></lucide-icon>&nbsp;{{ 'DASHBOARD.DOWNLOAD_IMAGE' | translate }}
      </a>&nbsp;&nbsp;
      <button (click)="downloadExcel()" class="btn btn-sm btn-outline-success">
        <lucide-icon name="file-spreadsheet" size="16"></lucide-icon><span class="d-none d-md-inline">&nbsp;{{ 'DASHBOARD.DOWNLOAD_EXCEL' | translate }}</span><span class="d-md-none">&nbsp;XLS</span>
      </button>&nbsp;&nbsp;
    </div>
  }
  <div style="text-align: center;">
    @if (!loading && barChartData!==null && barChartData.length>0) {
      <span>{{footer}}</span>
    }
  </div>
  <!--    <app-period-range [dashboardConfigs]="dashboardConfigs" (valueChange)="loadData(dashboardConfigs)"></app-period-range>-->
</div>
